// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Navigation from '@/components/Navigation.vue'
import left from '@/components/left.vue'
import derive from '@/components/derive.vue'
import router from './router'
import axios from 'axios';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts';
import cookies from 'vue-cookies';
// import '@/assets/style/reset.css';
// import 'amfe-flexible';
Vue.prototype.$cookies=cookies;
Vue.prototype.$store = store;
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App ,Navigation ,left,derive},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js